module.exports = __webpack_public_path__ + "img/orange_054.23399679.png";